import BSInfantMeatsProduct from 'models/BSInfantMeatsProduct'

export const packagingInitialState = {
  category: BSInfantMeatsProduct.category,
  subCategory: BSInfantMeatsProduct.subCategory,
  PackageType: {
    value: BSInfantMeatsProduct.PackageType,
    label: 'Package Type',
  },
  Size: BSInfantMeatsProduct.Size,
  NoAdditionalIngredients: BSInfantMeatsProduct.NoAdditionalIngredients,
  Organic: BSInfantMeatsProduct.Organic,
  MultiPackageType: BSInfantMeatsProduct.MultiPackageType,
  MultiPackageCount: BSInfantMeatsProduct.MultiPackageCount,
}

export const packageTypeOptions = [
  {
    value: '',
    label: 'Package Type',
    isDisabled: true,
  },
  { value: 'Jar', label: 'Jar' },
  { value: 'Plastic', label: 'Plastic' },
]
